/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Group_PlaceholderInputs */

const en_users_group_placeholder = /** @type {(inputs: Users_Group_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select groups…`)
};

const pt_br2_users_group_placeholder = /** @type {(inputs: Users_Group_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar grupos…`)
};

/**
* | output |
* | --- |
* | "Select groups…" |
*
* @param {Users_Group_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_group_placeholder = /** @type {((inputs?: Users_Group_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Group_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_group_placeholder(inputs)
	return pt_br2_users_group_placeholder(inputs)
});